import { PenLine, Sparkles } from 'lucide-react';
import { cn } from '@/lib/utils';
import { AutofillState } from '../utils/autofill';

const COPY = {
  auto: {
    Icon: Sparkles,
    tone: 'text-violet-500',
    text: 'Auto-filled from your files',
  },
  edited: {
    Icon: PenLine,
    tone: 'text-amber-600',
    text: 'Auto-filled from your files, then edited by you',
  },
} as const;

/** Whether a field was filled in from the dropped files, and whether it still
 * says what they said. */
export default function AutofillMark({
  state,
  className,
}: {
  state: AutofillState;
  className?: string;
}) {
  if (!state) return null;
  const { Icon, tone, text } = COPY[state];
  return (
    // The tooltip lives on the wrapper: `title` is not an SVG attribute.
    <span title={text} className={cn('inline-flex shrink-0', className)}>
      <Icon role="img" aria-label={text} className={cn('h-3.5 w-3.5', tone)} />
    </span>
  );
}

/** What the two marks mean, once per step — an unexplained icon beside a form
 * field is just noise. */
export function AutofillLegend({ show }: { show: boolean }) {
  if (!show) return null;
  return (
    <p className="mb-6 flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-muted-foreground">
      <span className="flex items-center gap-1.5">
        <Sparkles className="h-3.5 w-3.5 text-violet-500" />
        {COPY.auto.text}
      </span>
      <span className="flex items-center gap-1.5">
        <PenLine className="h-3.5 w-3.5 text-amber-600" />
        Auto-filled, then edited by you
      </span>
    </p>
  );
}
